import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Lock, CheckCircle, AlertCircle } from 'lucide-react';
import authService from '../services/authService.js';
import toast from 'react-hot-toast';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [form, setForm] = useState({ password: '', password_confirmation: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!token || !email) {
      setError('El enlace de restablecimiento es inválido o está incompleto.');
    }
  }, [token, email]);

  const handleChange = (e) => setForm(prev => ({...prev, [e.target.name]: e.target.value}));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password_confirmation) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    
    setLoading(true);
    setError('');

    try {
      const res = await authService.resetPassword({
        token,
        email,
        password: form.password,
        password_confirmation: form.password_confirmation
      });
      setSuccess(res.message);
      toast.success('Contraseña restablecida exitosamente');
      
      // Redirect after success
      setTimeout(() => navigate('/'), 3000);
    } catch (err) {
      const msgs = err.response?.data?.errors;
      if (msgs) {
        setError(Object.values(msgs).flat()[0]);
      } else {
        setError(err.response?.data?.message || 'Error al restablecer la contraseña.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="container" style={{ padding: '6rem 1rem' }}>
        <div className="glass-card animate-scale-in" style={{ textAlign: 'center', maxWidth: 500, margin: '0 auto' }}>
          <CheckCircle size={64} style={{ color: 'var(--success)', marginBottom: '1.5rem' }} />
          <h2 style={{ marginBottom: '1rem', color: 'var(--primary-dark)' }}>¡Contraseña Restablecida!</h2>
          <p className="text-muted" style={{ fontSize: '1.05rem', marginBottom: '2rem' }}>
            {success}
          </p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ padding: '4rem 1rem' }}>
      <div className="glass-card animate-fade-in" style={{ maxWidth: 500, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ display: 'inline-flex', padding: '16px', background: 'rgba(0,51,102,0.08)', borderRadius: '50%', color: 'var(--primary)', marginBottom: '1rem' }}>
            <Lock size={32} />
          </div>
          <h2 style={{ color: 'var(--primary-dark)', marginBottom: '0.5rem' }}>Crear Nueva Contraseña</h2>
          <p className="text-muted" style={{ fontSize: '0.95rem' }}>Para la cuenta: <strong>{email}</strong></p>
        </div>

        {error ? (
          <div className="alert alert-error" style={{ marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <AlertCircle size={20} />
            {error}
          </div>
        ) : null}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nueva Contraseña</label>
            <input 
              type="password" 
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
              minLength={8}
            />
            <small className="text-muted" style={{ fontSize: '0.8rem', display: 'block', marginTop: '4px' }}>
              Debe contener al menos 8 caracteres, 1 mayúscula, 1 minúscula y 1 número.
            </small>
          </div>

          <div className="form-group">
            <label>Confirmar Nueva Contraseña</label>
            <input 
              type="password" 
              name="password_confirmation"
              value={form.password_confirmation}
              onChange={handleChange}
              placeholder="••••••••"
              required
              minLength={8}
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-lg" 
            style={{ width: '100%', marginTop: '1rem', justifyContent: 'center' }}
            disabled={loading || !token || !email}
          >
            {loading ? <span className="spinner" /> : 'Restablecer Contraseña'}
          </button>
        </form>
      </div>
    </div>
  );
}
